<template>
  <div class="revisit body-container">
      <template v-if="!isSubmit">
          <div>
            <div class="top-info">
                <div class="title">尊敬的客户您好:</div>
                <div class="info">
                    您购买的<span>{{subscribeInfo.productName}}</span>产品可以预约回访时间，请填写预约日期和时间。保险公司将根据您所填时间进行电话回访，请注意保持手机畅通。
                    <div style="color:red;text-indent:0;">提示：此预约一天只能预约一次且不可预约当日与节假日。</div>
                </div>
            </div>
            <div class="body-list">
                <div class="row">
                    <div class="label">投保人</div>
                    <div class="value">{{subscribeInfo.policyerName||'-'}}</div>
                </div>
                <div class="row">
                    <div class="label">保单号</div>
                    <div class="value">{{subscribeInfo.policyNo||'-'}}</div>
                </div>
                <div class="row">
                    <div class="label">产品名称</div>
                    <div class="value">{{subscribeInfo.productName||'-'}}</div>
                </div>
                <div class="row">
                    <div class="label">联系电话</div>
                    <div class="value">{{subscribeInfo.policyerMobile||'-'}}</div>
                </div>
            </div>
            <div class="footer-form">
                <van-form class="form-body" @submit="onSubmit">
                    <van-field
                        class="date-time"
                        v-model="formList.dateTime"
                        is-link
                        readonly
                        label="预约日期"
                        placeholder="请选择日期"
                        @click="showPicker_date = true"
                    />
                    <van-field
                        class="times"
                        v-model="formList.times"
                        is-link
                        readonly
                        label="预约时间"
                        placeholder="请选择时间"
                        @click="showPicker_time = true"
                    />
                    <div class="formtbn">
                        <van-button round block type="info" :class="{ 'disabled': hasSubmit }" native-type="submit">提交</van-button>
                    </div>
                </van-form>
            </div>
            <van-popup v-model="showPicker_date" round position="bottom">
                <van-datetime-picker
                    @confirm="confirmDate"
                    @cancel="showPicker_date = false"
                    v-model="date"
                    :min-date="minDate"
                    type="date"
                    title="选择年月日"
                />
            </van-popup>
            <van-popup v-model="showPicker_time"  round position="bottom">
                <!-- <van-datetime-picker
                    @confirm="confirmTime"
                    @cancel="showPicker_time = false"
                    v-model="time"
                    type="time"
                    title="选择时间"
                    :min-hour="9"
                    :max-hour="17"
                /> -->
                <van-picker
                    title="选择时间"
                    show-toolbar
                    :columns="options"
                    @confirm="confirmTime"
                    @cancel="showPicker_time = false"
                />

            </van-popup>
          </div>
      </template>
      <template v-if="isSubmit">
          <div class="submit-Success">
              <div class="success"></div>
              <div class="title">感谢您的提交</div>
              <div class="info">工作人员将会在预约时间内进行回访<br/>请注意保持手机畅通</div>
          </div>
      </template>
  </div>
</template>

<script>
import moment from 'moment';
export default {
    data:()=>({
        formList:{
            dateTime:'',
            times:'',
        },
        date:new Date(),
        showPicker_time:false,
        showPicker_date:false,
        hasSubmit:false,
        isSubmit:false,
        product:'完美世界',
        policyNo:'',
        subscribeInfo:'',
        minDate:'',  //可选择的最小日期
        options:[
          '09:00-10:00',
          '10:00-11:00',
          '11:00-12:00',
          '12:00-13:00',
          '13:00-14:00',
          '14:00-15:00',
          '15:00-16:00',
          '16:00-17:00',
          '17:00-18:00'
        ],// 预约时间选项列表
    }),
    created(){
        this.policyNo= this.$route.params.policyNo
        //最小允许选择当前日期
        let dateLimit = new Date();
        this.minDate = new Date(moment(dateLimit).format('YYYY/MM/DD'));
        this.getRevisitInfo()
    },
    methods:{
        moment,
        // 提交表单
        onSubmit(){
            let current = moment(this.formList.dateTime)
            let disableFlag = this.getDisabledDate(current)
            if(disableFlag){
                this.$toast("当日以及节假日不能预约");
                return;
            }
            if(!this.formList.dateTime){
                this.$toast("日期不能为空");
                return;
            }
            if(!this.formList.times){
                this.$toast("时间不能为空");
                return;
            }
           this.$http({
                url: "/api/subscribeRevisit/submitSubscribe",
                type: "PUT",
                data: {
                    policyNo:this.policyNo,
                    date:this.formList.dateTime,
                    timeDesc:this.formList.times,
                    type:1
                },
            }).then((res)=>{
                if(res.httpCode==200){
                    this.hasSubmit = true
                    this.isSubmit=true
                }else{
                  this.$toast("您当日已有预约，请选择其他时间"); 
                }
            })
        },
        // 获取回访数据
        getRevisitInfo(){
            let url = `/api/subscribeRevisit/queryRevisitInfo/${this.policyNo}`
            this.$http({
                url: url,
                type: "GET",
            }).then((res)=>{
                this.subscribeInfo = res.data
            })
        },
        confirmTime(val){

            this.showPicker_time = false
            this.formList.times=val
        },
        confirmDate(){
            this.showPicker_date = false
            this.formList.dateTime = this.$tools.dateFormat(this.date,'yyyy-MM-dd')
        },
        // 禁用周末日期
        getDisabledDate(current){
            return (current < moment().endOf("day"))||current.day() == 6 ||  current.day() == 0 || ['2021-05-03','2021-05-04','2021-05-05'].includes(current.format('YYYY-MM-DD'))
        },
    }
}
</script>

<style lang="scss" scoped>
@import './reVisitManage';
</style>